import { MetadataEntityData } from '../../../metadata';
import { Entity } from '../../entity';
import { EntityFormDefinition, EntityFormId } from '../forms';

export const EntityViewNames = {
    [EntityFormId.Create]: 'Create',
    [EntityFormId.QuickCreate]: 'Quick Create',
}

export interface EntityDefinition extends Entity {
    name: string;
    metadata: MetadataEntityData;
    forms: EntityFormDefinition[];
}


